<ng-template #partSelect let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Add Items Manually</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row" *ngIf="!loading">
			<form [formGroup]="searchForm">
				<div class="col-md-12">
					<mat-form-field appearance="outline" class="searchbar">
						<input
						matInput
						#itemrec
						formControlName="searchVal"
						id="itemrec"
						class="margin-top"
						autocomplete="off"
						placeholder="* Item Search"
						(keyup.enter)="
							$event.stopPropagation();
							$event.preventDefault();
							itemSearch();
							$event.target.blur();
						"
						/>
						<div matSuffix class="text-right">
						<ng-container *ngIf="!issearching; else loading">
							<button
							mat-icon-button
							type="button"
							color="white"
							(click)="
								$event.stopPropagation();
								$event.preventDefault();
								itemSearch();
							"
							>
							<mat-icon>search</mat-icon>
							</button>
						</ng-container>
						<ng-template #loading>
							<mat-progress-spinner
							[diameter]="24"
							mode="indeterminate"
							color="primary"
							></mat-progress-spinner>
						</ng-template>
						</div>
					</mat-form-field>
				</div>
			</form>
		</div>
		<div class="row">
			<table *ngIf="items.length > 0" class="table table-fixed table-striped">
				<tr class="thead-dark">
					<th>Item #</th>
					<th>Description</th>
					<th>QOH at Warehouse</th>
					<th>QOH at Store</th>
					<th></th>
				</tr>
				<tr *ngFor="let part of items">
					<td>
						{{part.stockid}}
					</td>
					<td>
						{{part.description}}
					</td>
					<td>
						{{part.fromqoh}}
					</td>
					<td>
						{{part.toqoh}}
					</td>
					<td>
						<div class="row">
							<div class="col-2 mt-3 ml-0 mr-0 ml-auto">
								<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm mr-md-2" (click)="decrement(part)">
									<small><i class="material-icons">remove</i></small>
								</button>
							</div>
							<div class="col-6 m-0 ">
								<mat-form-field appearance="outline">
									<mat-label>Qty</mat-label>
									<span matPrefix>#</span>
									<input matInput tabindex="{{ i + 2 }}" type="number" value="{{ part.quantity | number }}" autofocus (input)="updateSearchQuantity($event, part )" class="text-right">
								</mat-form-field>
							</div>
							<div class="col-2 mt-3 ml-0 mr-0 mr-auto ">
								<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm mr-md-2" (click)="increment(part)">
									<small>
										<i class="material-icons">add</i></small>
								</button>
							</div>
							<div class="col-2 mt-3 ml-0 mr-0 mr-auto">
								<button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2" (click)="addItems(items)">
									<small><i class="material-icons">add_box</i></small>
								</button>
							</div>
						</div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</ng-template>
<ng-template #nonStock let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Add Non-Stocked Part</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<form [formGroup]="nonStockForm">
			<div class="row" *ngIf="!loading">

				<div class="col-md-4">
					<mat-form-field appearance="outline" class="searchbar">
						<mat-label>Description</mat-label>
						<input matInput #itemdesc formControlName="itemDesc" id="itemdesc" class="margin-top" autocomplete="off" placeholder="* Description">
					</mat-form-field>
				</div>
				<div class="col-md-3">
					<mat-form-field appearance="outline" class="searchbar">
						<mat-label>Quantity</mat-label>
						<input matInput type="number" #itemqty formControlName="itemQty" id="itemqty" class="margin-top" autocomplete="off" placeholder="0" appNumericField>
					</mat-form-field>
				</div>
				<div class="col-md-3">
					<mat-form-field appearance="outline" class="searchbar">
						<mat-label>Price</mat-label>
						<input matInput type="number" #itemprice formControlName="itemPrice" id="itemprice" class="margin-top" autocomplete="off" placeholder="0" appNumericField>
					</mat-form-field>
				</div>
				<div class="col-md-2">
					<button class="align-middle" mat-icon-button type="button" color="white" (click)="$event.stopPropagation();$event.preventDefault();nsAdd()">
						<mat-icon>add</mat-icon> Add To Order
					</button>
				</div>

			</div>
		</form>
	</div>
</ng-template>

<ng-template #loadscreen let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title"> Load Order in Progress</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark savescreen">

		<div class="row">
			<div class="col-sm-3">Date</div>
			<div class="col-sm-6">Product Lines</div>
			<div class="col-sm-3"></div>
		</div>
		<div class="row filerow" *ngFor="let s of savedorders">
			<div class="col-sm-3">{{ s.date_updated }}</div>
			<div class="col-sm-6">{{ s.productlines }}</div>
			<div class="col-sm-3">
				<button mat-stroked-button color="primary" class="mt-2 mb-2" (click)="loadOrder(s)">Load</button>
				<button mat-stroked-button color="warn" class="mt-2 mb-2" (click)="removeOrder(s)">Remove</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #savescreen let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title"> Save Order </h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark savescreen">

		<div class="row">
			<div class="col-sm-3">Date</div>
			<div class="col-sm-6">Product Lines</div>
			<div class="col-sm-3"></div>
		</div>
		<div class="row filerow" *ngFor="let s of savedorders">
			<div class="col-sm-3">{{ s.date_updated }}</div>
			<div class="col-sm-6">{{ s.productlines }}</div>
			<div class="col-sm-3"><button mat-stroked-button color="primary" class="mt-2 mb-2" (click)="saveOrder(s)">Replace Saved Order</button></div>
		</div>
		<div class="row filerow">
			<div class="col-sm-12"> <button mat-stroked-button color="primary" class="mt-2 mb-2" (click)="saveOrder('')">New Saved Order</button> </div>
		</div>
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Store Reorder Reports</h4>
						<p class="card-category text-right">Reordering</p>
					</div>
					<div class="card-body ">
						<ng-container>
							<div class="row">
								<div class="col-md-4">
									<mat-form-field appearance="fill">
										<mat-label>Location</mat-label>
										<mat-select [formControl]="branch" (selectionChange)="resetReorder();">
											<mat-option *ngIf="branches.length != 1" value=""> ---- All Locations ---- </mat-option>
											<mat-option *ngFor="let v of branches" [value]="v.loccode">
												{{v.locationname}}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>History As Of</mat-label>
										<input matInput (dateChange)="resetReorder();" [formControl]="dateCtrl" [matDatepicker]="payfrom">
										<mat-datepicker-toggle matSuffix [for]="payfrom"></mat-datepicker-toggle>
										<mat-datepicker #payfrom></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-4" style="text-align:center;vertical-align:center;">
								<mat-form-field appearance="outline">
										<mat-label>Months of History to include</mat-label>
										<input matInput [formControl]="histMonths">
									</mat-form-field>
								</div>
							</div>
							<div class="row" >
							<div class="col-4">
								<mat-form-field appearance="fill">
										<mat-label>Vendor</mat-label>
										<mat-select [formControl]="vendor">
											<mat-option *ngIf="vendors.length != 1" value=""> ---- All Vendors ---- </mat-option>
											<mat-option *ngFor="let v of vendors" [value]="v.supplierid">
												{{v.supplierid}} - {{v.suppname}}
											</mat-option>
										</mat-select>
									</mat-form-field>
							</div>
							<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Weeks of inventory to stock</mat-label>
										<input matInput [formControl]="planWeeks">
									</mat-form-field>
								</div>
								<div class="col-4" style="text-align:center">
								<mat-slide-toggle [formControl]="showOverstock"></mat-slide-toggle><mat-label>&nbsp;&nbsp;Show Overstock Items</mat-label>
								<mat-slide-toggle [formControl]="showZeroes"></mat-slide-toggle><mat-label >&nbsp;&nbsp;Show Zero Sales Items</mat-label>
								
							</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<mat-form-field appearance="outline" class="full-width">
										<mat-chip-list #chipListRef></mat-chip-list>
										<input matInput #prodInput [formControl]="prodCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipListRef" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="add($event)" placeholder="Add a category... * to add all matching">
										<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
											<mat-option *ngFor="let prod of filteredProds" [value]="prod.categoryid">
												{{prod.categorydescription}}
											</mat-option>
										</mat-autocomplete>
									</mat-form-field>
									<span (click)="clearAll()" class="clear-all-btn" *ngIf="prods.length">
										<mat-icon class="mt-3">clear</mat-icon>
										Clear All ( {{prods.length }} )
									</span>
									<div class="chips-container" *ngIf="prods.length">
										<mat-chip-list #chipList aria-label="Category Selection">
											<mat-chip *ngFor="let prod of prods" [selectable]="true" [removable]="true" (removed)="remove(prod)">
												{{prod.categoryid}} - {{prod.categorydescription}}
												<mat-icon matChipRemove>cancel</mat-icon>
											</mat-chip>

										</mat-chip-list>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 pull-right">
									<button mat-stroked-button color="warn" class="mt-2 mb-2" (click)="getRecomendations()">Run</button>&nbsp;&nbsp;
									<mat-slide-toggle *ngIf="results.length" [formControl]="appendResults"></mat-slide-toggle>
										<mat-label *ngIf="results.length">&nbsp;&nbsp;Append Results&nbsp;&nbsp;</mat-label>&nbsp;&nbsp;
								<!--	<button mat-stroked-button color="warn" class="mt-2 mb-2" (click)="addMore()">Add Items Manually</button>
									<button *ngIf="results.length" mat-stroked-button color="warn" class="mt-2 mb-2" (click)="addNonStock()">Add Non-Stock</button>
									<button *ngIf="results.length" mat-stroked-button color="primary" class="mt-2 mb-2" (click)="save()">Save For Later</button>
									<button *ngIf="savedorders.length > 0" class="mt-2 mb-2" mat-stroked-button color="primary" (click)="loadOrders()">Load Saved Reorder</button> -->
									
									<button *ngIf="results.length" mat-stroked-button color="warn" class="mt-2 mb-2" (click)="restart()">Start Over</button>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12" #print_table>

									<div class="row mt-3">
										<div class="col-md-4 noprint" *ngIf="!loading && results.length">
											<button *ngIf="branch.value != '' && branch.value != servicelocation" mat-stroked-button color="success" (click)="createTransfer()">Create Transfer Request</button>
											<button *ngIf="branch.value != '' && branch.value == servicelocation && vendor.value != ''" mat-stroked-button color="success" (click)="createPO()">Create Purchase Order</button>

											&nbsp;&nbsp;
											<button mat-raised-button (click)="$event.preventDefault();exportPdf()">
												<i class="fa fa-file-pdf-o"></i> PDF
											</button>
											&nbsp;&nbsp;
											<button mat-raised-button (click)="$event.preventDefault();exportXls()">
												<i class="fa fa-file-pdf-o"></i> XLS
											</button>
										</div>
										<div class="col-md-4 noprint" *ngIf="!loading && results.length">

										</div>
										<div class="col-md-4" *ngIf="!loading && results.length">

											<h4 class="ml-auto text-right">Total Quantity Purchased: {{ getTotalQtyPurchase() }}</h4>
											<h4 class="ml-auto text-right">Total  Value: {{ getTotalQtyTimesPrice()
												 | currency }}</h4>

										</div>
									</div>

									<div class="table table-responsive text-center" *ngIf="loading">
										<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</div>
									<div class="table-wrapper"  *ngIf="!loading && results.length">
									<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
									  <table class="table table-sm table-striped">
										<thead class="thead-dark">
										  <tr>
											<th class="text-center ">
											</th>
											<th (click)="sortBy('stockid')">Item#</th>
											<th (click)="sortBy('description')">Description</th>
											<th (click)="sortBy('qoh')" class="text-center">QOH</th>
											<th class="text-center">Case Qty</th>
											<th (click)="sortBy('categoryid')" class="text-center">Category</th>
											<th class="text-center">Price</th>

											<th (click)="sortBy('thismo')" class="text-center">Total Sold</th>
											<th class="text-center">Available</th>
											<th class="text-center">Back/Ord</th>
											<th *ngIf="config.liveinventory" class="text-center">On Order</th>
											<th class="text-center noshow">Recommended Request</th>
											<th (click)="sortBy('qty_purchase')"class="text-center noprint">Recommended Request</th>
											<th class="text-center noprint"></th>
										  </tr>
										</thead>
										<tbody>
										<ng-container *ngFor="let item of dataObs | async;let i = index">
										<tr class="datarow">
											<td class="text-center ">
												{{ i + 1 }}.
											</td>
											<td>{{ item.stockid }}</td>
											<td>{{ item.description }}</td>
											<td class="text-center">{{ item.qoh }}</td>
											<td class="text-center">{{ item.conversionfactor }} </td>
											<td class="text-center">{{ item.categoryid }}</td>
											<td class="text-center">{{ item.price | currency }}</td>
											<td class="text-center" (click)="toggleHist(item.stockid)">{{ item.totalsales }}</td>
											<td class="text-center">{{ item.avail }}</td>
											<td class="text-center">{{ item.qos }}</td>
											<td *ngIf="config.liveinventory" class="text-center">{{item.qop}}</td>
											<td class="text-center noshow">
												{{ item.qty_purchase }}
											</td>
											<td class="text-center noprint">
											  <div class="quantity-control">
												<button tabindex="-1" mat-icon-button (click)="decrementQty(item)">
												  <mat-icon>remove_circle</mat-icon>
												</button>
												<mat-form-field appearance="outline" class="quantity-input">
												  <input matInput type="text" [(ngModel)]="item.qty_purchase" (input)="updateBuyQuantity($event, item)" class="text-right ">
												</mat-form-field>
												<button tabindex="-1" mat-icon-button (click)="incrementQty(item)">
												  <mat-icon>add_circle</mat-icon>
												</button>
											  </div>
											</td>


											<!-- <td class="text-right noprint">

												<div class="quantity-control">


											  <mat-form-field appearance="outline">
												<mat-label>Quantity</mat-label>
												<span matPrefix>#</span>
												<input matInput type="text" [(ngModel)]="item.qty_purchase" (input)="updateBuyQuantity($event, item)" class="text-right mt-2" [ngClass]="{'focus': item === highlightedItem}">
											  </mat-form-field>

											</td> -->
											<td class="text-center noprint">
											  <button tabindex="-1" mat-icon-button (click)="confirmRemoveItem(item)" matTooltip="Remove Item">
												<mat-icon>delete</mat-icon>
											  </button>
											</td>
										  </tr>
										  <tr *ngIf="showdetail == item.stockid">
											<td *ngFor="let month of item.history.monthlysales">
											{{month.label}} : {{month.value}}
											</td>
										  </tr>
										  </ng-container>
										</tbody>
									  </table>
									</div>
									<div class="table" *ngIf="!loading && !results.length">
										<h4 class="text-center"> No Results</h4>
									</div>

								</div>
							</div>

						</ng-container>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
